import Model from './model.js'
import Contact from './contact.js'
import Deal from './deal.js'

export default class SMS extends Model {
    static _routeKey = 'sms'

    static _attributes = {
        number: null,
        description: '',
        whatsapp_template_id: null,
    }

    publishedStates = ['draft', 'sent']

    _tailIgnore = [
        '_tailIgnore',
        'tailIgnore',
        'tail',
        'vue',
        'created_at',
        'updated_at',
        'id',
        'belongs_type',
        '$help',
        '$log',
        'user_id',
        'publishedStates',
    ]

    tail = {
        number: () => [
            'Sent to',
            this.vue.$help.e164ToNumber(this.number),
        ],
        description: () => ['Message', this.description],
        belongs_id: () => [
            'Associated deal',
            parseInt(this.belongs_type) != 102
                ? this.belongs_id
                : 'No deal associated',
        ],
        created_by_user_id: () => [
            'sent by',
            this.created_by_user_id,
        ],
        createdDescription: () => this.description,
    }

    _logIcon() {
        return 'IconMessageDraftCircle'
    }

    timeline(user) {
        let t = this._timeline(user)
        let l = this.level('deal')

        let options = this.published_at == null ? {
            Edit: () => this.edit(),
            Delete: () => this.delete(),
        } : null

        let smsType = this.whatsapp ? 'whatsapp' : 'sms'
        // let title = this.published_at == null ? this.entry.from + ' created a draft' : this.entry.from + ' messaged ' + new Contact(t.contact).fullName();
        let sentBy = this.published_at != null ? new Contact(this.created_by).fullName() : null
        let title = this.created_by.first_name + ' '+ (this.published_at == null ? 'created a draft '+smsType+' to' : 'messaged') +' ' + this.entry.to

        // if (this.user_id == null) {
        //     // title = new Contact(t.contact).fullName() + ' messaged you'
        //     sentBy = new Contact(t.contact).fullName()
        // }

        let whatsapp = {};

        if (this.whatsapp) {
            whatsapp = {
                delivered: this.whatsapp_delivered ? this.vue.$moment(this.whatsapp_delivered).format('YYYY-MM-DD HH:mm') : 'Undelivered',
                read: this.whatsapp_read ? this.vue.$moment(this.whatsapp_read).format('YYYY-MM-DD HH:mm') : 'Unread',
            };
        }

        return {
            title: title,
            description: this.description,
            created_at: this.created_at,
            icon: this.published_at == null ? 'IconMessageDraftCircle' : (this.whatsapp ? 'IconWhatsapp' : 'IconMessageCircle'),
            breakdown: {...{
                'Sent by': sentBy,
                Message: this.description,
                'sent to': this.vue.$help.e164ToNumber(this.number),
                'Associated deal': l == false ? null : { type: 'NuxtLink', to: l.link, text: l.title },
            }, ...whatsapp },
            options: options,
        }
    }

    edit() {
        this.vue.$event.$emit('modal-open', {
            view: 'SMS',
            editingModel: this,
            modelId: this.belongs_id,
            modelType: this.belongs_type,
            options: {
                sms: this,
            },
        })
    }

    level(only = null) {
        if (
            this.belongs_type !== undefined &&
            this.belongs != null
        ) {
            let title = ''
            let link = ''
            let data = null

            switch (true) {
                case this.vue.$help.idName(
                    this.belongs_type,
                ) == 'deal':
                    link = '/deal/' + this.belongs_id

                    data = new Deal(this.belongs)

                    title = data.getName()
                    break

                case this.vue.$help.idName(
                    this.belongs_type,
                ) == 'contact' && only == null:
                    data = new Contact(this.belongs)

                    title = data.fullName()

                    link = '/contact/' + this.belongs_id
                    break
                default:
                    return false
            }

            return {
                model: this.vue.$help.idName(
                    this.belongs_type,
                ),
                data: data,
                title: title,
                link: link,
            }
        }

        return false
    }

    status() {
        switch (true) {
            case this.twilio_status == 'delivered':
                return ['Sent SMS', 'IconSmsDelivered', 'Delivered']
            case this.twilio_status == 'failed':
            case this.twilio_status == 'undelivered':
                return ['Sent SMS', 'IconSmsFailed', 'Undelivered']
            case this.created_by_user_id == null:
                return ['Received SMS', 'IconSmsReceived', 'Received']
            default:
                return ['Sent SMS', 'IconSmsSent', 'Sent']
        }
    }

    delete() {
        this.vue.$event.$emit('modal-open', {
			view: 'Confirm',
			options: {
				action: '/sms/' + this.id,
				message: 'Are you sure you want to delete this draft SMS?',
				button: 'Delete',
				method: 'DELETE',
				head: 'Delete draft SMS',
			},
		})
    }
}
